export enum Difficulty { EASY = 5, MEDIUM = 8, HARD = 15 };
export enum Time { TEN = 10, TWENTY = 20, THIRTY = 30, SIXTY = 60, ONE_TWENTY = 120 };
